/* unplugin-vue-components disabled */import { render } from "./OrderGet.vue?vue&type=template&id=b418bed6"
import script from "./OrderGet.vue?vue&type=script&lang=js"
export * from "./OrderGet.vue?vue&type=script&lang=js"

import exportComponent from "E:\\电梯项目文档\\lcFrontEnd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__